// extracted by mini-css-extract-plugin
export default {"receivedMessage":"ChatMessage_receivedMessage__Kf9L6","sendedMessage":"ChatMessage_sendedMessage__TqIYX"};